<template>
  <div id="projects" class="site">
    <div class="project-grid" v-scroll-reveal>
      <router-link
        v-for="(project, index) in projects.slice(6 - projects.length - 6)"
        :key="index"
        class="project-container"
        :to="`projekte/${project.path}`"
        v-scroll-reveal
        ><div
          class="project-img"
          :style="{ backgroundImage: `url(&quot;${project.image}&quot;)` }"
        >
          <div class="project-content">
            <div class="tag-wrapper">
              <div class="tag">
                <p>{{ project.tag }}</p>
              </div>
            </div>
            <div class="project-title">
              <h2>{{ project.title }}</h2>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  title: "Projekte - Ocular",
  computed: {
    projects() {
      return this.$store.state.projects;
    },
  },
};
</script>
<style lang="scss" scoped>
#projects {
  padding-top: 7vh;
}
@media only screen and (max-width: 1024px) {
  #projects {
    padding-top: 12vh;
  }
}
</style>
